import Head from 'next/head';
import {useRouter} from 'next/router';

import {HeadSEO} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';
import {SubscriptionPlanProductType, SubscriptionPlansProvider} from '@udemy/subscription-graphql';

import {PageProps} from 'src/types/page-props';

import {useCanonicalUrl} from '../../hooks/useCanonicalUrl';
import {META_DEFAULT_BASE_URL} from '../../lib/constants';
import {
    CareerAcademyOverviewPage,
    CareerAcademyOverviewPageProps,
} from './career-academy-overview-page.react-component';

export type CareerAcademyOverviewPageFeatureProps = PageProps & CareerAcademyOverviewPageProps;

export function CareerAcademyOverviewPageFeature(props: CareerAcademyOverviewPageFeatureProps) {
    const {gettext} = useI18n();
    const router = useRouter();
    const {url: canonicalUrl} = useCanonicalUrl([], META_DEFAULT_BASE_URL);

    const metaProps = {
        title: gettext('All Career Accelerators | Udemy'),
        description: gettext(
            'Reimagine your career with Udemy’s Career Accelerators. Gain real-world skills through structured courses to stand out across a variety of career paths.',
        ),
    };

    return (
        <>
            <HeadSEO
                title={metaProps.title}
                ogTitle={metaProps.title}
                description={metaProps.description}
                ogDescription={metaProps.description}
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[props.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            <SubscriptionPlansProvider
                subscriptionPlanQueryVariables={[
                    {
                        filters: {
                            productType: SubscriptionPlanProductType.Consumersubscription,
                        },
                        marketingURL: `${new URL(canonicalUrl).origin}${router?.asPath}`,
                    },
                ]}
            >
                <CareerAcademyOverviewPage {...props} />
            </SubscriptionPlansProvider>
        </>
    );
}
